<template>
  <v-app>
    <v-app-bar app>
      <div class="d-flex align-center">
        <!-- <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="@/assets/CompanyLogo.jpg"
          transition="scale-transition"
          width="40"
        /> -->

        <router-link to="/"
          ><v-img
            alt="Vuetify Name"
            class="shrink mt-2 mb-2"
            contain
            min-width="100"
            src="@/assets/CompanyLogo.jpg"
            width="140"
        /></router-link>

        <div class="ml-5 hidden-sm-and-down">
          <span>PROMPT. PROFESSIONAL. PERFECT</span>
        </div>
      </div>

      <v-spacer></v-spacer>
      <router-link to="/" class="hidden-sm-and-down">
        <v-btn text>
          <span class="mr-2">Home</span>
        </v-btn>
      </router-link>
      <router-link to="/diamond-contractor" class="hidden-sm-and-down">
        <v-btn text>
          <span class="mr-2">DIAMOND CONTRACTOR</span>
        </v-btn>
      </router-link>
      <router-link to="/ductless" class="hidden-sm-and-down">
        <v-btn text>
          <span class="mr-2">DUCTLESS SOLUTIONS</span>
        </v-btn>
      </router-link>
      <router-link to="/about" class="hidden-sm-and-down">
        <v-btn text>
          <span class="mr-2">About Us</span>
        </v-btn>
      </router-link>

      <v-menu left bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" class="d-md-none">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item to="/">
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item>
          <v-list-item to="/diamond-contractor">
            <v-list-item-title>Diamond Contractor</v-list-item-title>
          </v-list-item>
          <v-list-item to="/ductless">
            <v-list-item-title>Ductless Solutions</v-list-item-title>
          </v-list-item>
          <v-list-item to="/about">
            <v-list-item-title>About Us</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-content>
      <router-view></router-view>
    </v-content>
    <v-footer dark padless>
      <v-layout my-3 text-center>
        <v-flex>
          <div style="font-size:.7rem">REQUEST SERVICE: 301-922-0524</div>
          <div style="font-size:.7rem">&#9400; 2019 HOWARD MECHANICAL</div>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
// import HelloWorld from "./components/HelloWorld";

export default {
  name: "App",

  components: {
    // HelloWorld
  },

  data: () => ({
    //
  })
};
</script>
<style scoped>
.v-menu__content {
  width: 100%;
  max-width: 100%;
  top: 54px !important;
  left: 0 !important;
}
</style>
